import { createAsyncAction } from "../helpers";
import { createAction } from "redux-actions";

export const getPlayersAsyncAction = createAsyncAction("GET_PLAYERS");

export const updatePlayerTitleAsyncAction = createAsyncAction(
	"UPDATE_PLAYER_TITLE"
);

export const exportPlayerDataAsyncAction = createAsyncAction("EXPORT_PLAYERS");

export const getTournamentsAsyncAction = createAsyncAction(
	"GET_PLAYER_TOURNAMENTS_REQUEST",
	"GET_PLAYER_TOURNAMENTS_SUCCESS",
	"GET_PLAYER_TOURNAMENTS_FAILURE",
	"GET_PLAYER_TOURNAMENTS_CANCEL"
);

export const getPlayerDetailAsyncAction = createAsyncAction(
	"GET_PLAYER_DETAIL_REQUEST",
	"GET_PLAYER_DETAIL_SUCCESS",
	"GET_PLAYER_DETAIL_FAILURE",
	"GET_PLAYER_DETAIL_CANCEL"
);

export const updatePlayerSuspendAsyncAction = createAsyncAction(
	"PUT_PLAYER_SUSPEND_REQUEST",
	"PUT_PLAYER_SUSPEND_SUCCESS",
	"PUT_PLAYER_SUSPEND_FAILURE",
	"PUT_PLAYER_SUSPEND_CANCEL"
);

export const resetAction = createAction("PLAYER_RESET_ACTION");
